import React, {useEffect, useState} from "react";
import {Textarea, Tabs, Checkbox} from "@mantine/core";
import {exportCompetitionAsHTML, exportCompetitionAsString} from "../../services/HTMLExportService";
import {getCompetition} from "../../services/FirestoreService";

interface Props {
    competitionOverview: CompetitionOverview | undefined
}

function ResultExport({competitionOverview}: Props) {
    const [competition, setCompetition] = useState<Competition | undefined>(undefined)
    //HTML Export
    const [html, setHTML] = useState<string>('<h1>Loading...</h1>')
    //Text Export
    const [youngsterOnlyPB, setYoungsterOnlyPB] = useState<string | undefined>(undefined)
    const [activeOnlyPB, setActiveOnlyPB] = useState<string | undefined>(undefined)
    const [youngsterAll, setYoungsterAll] = useState<string | undefined>(undefined)
    const [activeAll, setActiveAll] = useState<string | undefined>(undefined)
    const [isOnlyPB, setOnlyPB] = useState<boolean>(true)
    const [showUnits, setShowUnits] = useState<boolean>(true)

    const exportData = (competition: Competition) => {
        setHTML(exportCompetitionAsHTML(competition))
        const resultAll = exportCompetitionAsString(competition, false, showUnits)
        setYoungsterAll(resultAll.youngster)
        setActiveAll(resultAll.active)
        const resultOnlyPb = exportCompetitionAsString(competition, true, showUnits)
        setYoungsterOnlyPB(resultOnlyPb.youngster)
        setActiveOnlyPB(resultOnlyPb.active)
    }

    useEffect(() => {
        if (!competitionOverview) {
            return;
        }
        getCompetition(competitionOverview.id)
            .then(competition => {
                    setCompetition(competition)
                    exportData(competition)
                }
            )


    }, [competitionOverview])

    useEffect(() => {
        if (competition) {
            exportData(competition)
        }
    }, [showUnits]);

    return (
        <>
            <Tabs defaultValue="html" color="red">
                <Tabs.List>
                    <Tabs.Tab value="html">HTML</Tabs.Tab>
                    <Tabs.Tab value="text">Text</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="html">
                    <Textarea
                        autosize
                        value={html}
                    />
                </Tabs.Panel>
                <Tabs.Panel value="text">
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <Checkbox defaultChecked color="red" style={{marginTop: 10}} label={"Nur PBs anzeigen"}
                                  checked={isOnlyPB} onChange={(event) => {
                            setOnlyPB(event.currentTarget.checked)
                        }}/>
                        <Checkbox defaultChecked color="red" style={{marginTop: 10, marginLeft: 10}}
                                  label={"Einheiten anzeigen"} checked={showUnits} onChange={(event) => {
                            setShowUnits(event.currentTarget.checked)
                        }}/>
                    </div>

                    <p style={{marginTop: 20, marginBottom: 0}}
                       hidden={isOnlyPB ? !activeOnlyPB : !activeAll}>U18/U20/U23/Aktive</p>

                    <Textarea
                        autosize
                        value={isOnlyPB ? activeOnlyPB : activeAll}
                        hidden={isOnlyPB ? !activeOnlyPB : !activeAll}
                    />
                    <p style={{marginTop: 20, marginBottom: 0}}
                       hidden={isOnlyPB ? !youngsterOnlyPB : !youngsterAll}>Nachwuchs</p>
                    <Textarea
                        autosize
                        value={isOnlyPB ? youngsterOnlyPB : youngsterAll}
                        hidden={isOnlyPB ? !youngsterOnlyPB : !youngsterAll}
                    />
                    {(isOnlyPB ? !youngsterOnlyPB && !activeOnlyPB : !youngsterAll && !activeAll) &&
                        <div style={{marginTop: 15}}> Keine Werte vorhanden.</div>}
                </Tabs.Panel>

            </Tabs>
        </>
    )
}

export default ResultExport
